module.exports = __webpack_public_path__ + "img/sleet.07dff5df.svg";